<div class="sc" #lienzo>
  <!-- Cabecera del panel. Deliberadamente delgada: la ficha es la protagonista, y todo lo que se
       ponga aquí le roba altura al documento. -->
  <div class="sc-bar">
    <button type="button" class="sc-back" (click)="volver()" title="Salir de la ficha · Esc">
      <i class="fa-solid fa-xmark"></i> Salir
    </button>

    <div class="sc-id" *ngIf="row as r">
      <span class="sc-cat" *ngIf="category" [style.color]="category.color">
        <i [class]="category.icon"></i> {{ category.name }}
      </span>
      <h1>{{ r.project.name }}</h1>
    </div>

    <div class="sc-meta" *ngIf="row as r">
      <span class="sc-chip" *ngIf="r.taskCount">
        <i class="fa-solid fa-diagram-project" [style.color]="accent"></i> {{ progress }}% del trabajo
      </span>
      <span class="sc-chip" *ngIf="r.deliverablesTotal">
        <i class="fa-solid fa-list-check" [style.color]="accent"></i>
        {{ r.deliverablesDone }}/{{ r.deliverablesTotal }} entregables
      </span>
      <span class="sc-status" [style.background]="PROJECT_STATUS_META[r.status].color"
        [title]="PROJECT_STATUS_META[r.status].hint">
        <i [class]="PROJECT_STATUS_META[r.status].icon"></i> {{ PROJECT_STATUS_META[r.status].label }}
      </span>
      <button type="button" class="sc-ghost" *ngIf="hayFicha" (click)="alternarPantallaCompleta()"
        [title]="enPantallaCompleta ? 'Volver a la ventana' : 'Pantalla completa del navegador'">
        <i class="fa-solid" [ngClass]="enPantallaCompleta ? 'fa-compress' : 'fa-expand'"></i>
        {{ enPantallaCompleta ? 'Salir de pantalla completa' : 'Pantalla completa' }}
      </button>
      <button type="button" class="sc-dl" *ngIf="hayFicha" (click)="descargar()"
        title="Bajarla como archivo .html para compartirla fuera del panel">
        <i class="fa-solid fa-download"></i> Descargar
      </button>
      <span class="sc-esc" *ngIf="!enPantallaCompleta"><kbd>Esc</kbd> para salir</span>
    </div>
  </div>

  <div class="sc-err" *ngIf="errorMsg"><i class="fa-solid fa-triangle-exclamation"></i> {{ errorMsg }}</div>

  <p-skeleton *ngIf="loading" height="calc(100vh - 190px)" borderRadius="14px"></p-skeleton>

  <!-- Contenedor vacío a propósito: el iframe lo crea el componente y lo mete aquí, porque con
       `[srcdoc]` en la plantilla el frame se queda en about:blank. Ver el docblock del componente. -->
  <div #marco class="sc-frame" *ngIf="!loading && hayFicha"></div>

  <!-- Sin ficha NO es un error: es el estado normal de casi todos los proyectos. -->
  <div class="sc-empty" *ngIf="!loading && !hayFicha && !errorMsg">
    <i class="fa-regular fa-image"></i>
    <h2>Este proyecto todavía no tiene ficha visual</h2>
    <p>
      La ficha se redacta y se carga desde una sesión de Claude Code al aterrizar el proyecto, con
      el comando <code>/proyecto-ficha {{ slug }}</code>. Aparece aquí en cuanto se sube, sin deploy.
    </p>
  </div>
</div>
